import React from 'react';

export const Badge = ({ variant = 'primary', className = '', children, ...props }) => {
  let variantClass = '';
  
  switch (variant) {
    case 'destructive':
      variantClass = 'bg-danger';
      break;
    case 'outline':
      variantClass = 'border border-secondary text-secondary bg-transparent';
      break;
    case 'secondary':
      variantClass = 'bg-secondary';
      break;
    case 'success':
      variantClass = 'bg-success';
      break;
    case 'warning':
      variantClass = 'bg-warning';
      break;
    case 'info':
      variantClass = 'bg-info';
      break;
    default:
      variantClass = 'bg-primary';
  }
  
  return (
    <span className={`badge ${variantClass} ${className}`} {...props}>
      {children}
    </span>
  );
};